module.exports = __webpack_public_path__ + "media/images/donations/jcb-76fd30126c440540bd9ffcebe11773cc.png";